import {
    SettingsActionTypes,
    ISettingsState,
    GET_SETTINGS_BEGIN,
    GET_SETTINGS_SUCCESS,
    GET_SETTINGS_FAILURE,
    SET_SETTINGS_BEGIN,
    SET_SETTINGS_SUCCESS,
    SET_SETTINGS_FAILURE,
    GET_ADMIN_SETTINGS_BEGIN,
    GET_ADMIN_SETTINGS_SUCCESS,
    GET_ADMIN_SETTINGS_FAILURE,
    SET_ADMIN_SETTINGS_BEGIN,
    SET_ADMIN_SETTINGS_SUCCESS,
    SET_ADMIN_SETTINGS_FAILURE
} from './ActionTypes';

const initialState: ISettingsState = {
    defaultFilters: [],
    defaultEventCategories: [],
    markerIsLiveHours: 0,
    errorEmails: [],
    activityDaysBack: 14,
    loading: false,
    settingsLoading: false,
};

const settingsReducer = (state = initialState, action: SettingsActionTypes): ISettingsState => {
    switch (action.type) {
        case GET_SETTINGS_BEGIN:
            return {
                ...state,
                loading: true
            };

        case GET_SETTINGS_SUCCESS:
            return {
                ...state,
                loading: false,
                defaultFilters: action.payload.defaultFilters,
                defaultEventCategories: action.payload.defaultEventCategories,
                markerIsLiveHours: action.payload.markerIsLiveHours,
                errorEmails: action.payload.errorEmails || [],
            }

        case GET_SETTINGS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case SET_SETTINGS_BEGIN:
            return {
                ...state,
                loading: true
            }
        case SET_SETTINGS_SUCCESS:
            return {
                ...state,
                loading: false,
                defaultFilters: action.payload.defaultFilters,
                defaultEventCategories: action.payload.defaultEventCategories,
                markerIsLiveHours: action.payload.markerIsLiveHours,
                errorEmails: action.payload.errorEmails || [],
            }
        case SET_SETTINGS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            }
        case GET_ADMIN_SETTINGS_BEGIN:
            return {
                ...state,
                settingsLoading: true,
                settingsError: undefined
            }
        case GET_ADMIN_SETTINGS_SUCCESS:
            return {
                ...state,
                settingsLoading: false,
                errorEmails: action.payload.recipients || [],
                activityDaysBack: action.payload.activityDaysBack ?? 14,
            }
        case GET_ADMIN_SETTINGS_FAILURE:
            return {
                ...state,
                settingsLoading: false,
                settingsError: action.payload,
            }
        case SET_ADMIN_SETTINGS_BEGIN:
            return {
                ...state,
                settingsLoading: true,
                settingsError: undefined
            }
        case SET_ADMIN_SETTINGS_SUCCESS:
            return {
                ...state,
                settingsLoading: false,
                errorEmails: action.payload.recipients || [],
                activityDaysBack: action.payload.activityDaysBack ?? 14,
            }
        case SET_ADMIN_SETTINGS_FAILURE:
            return {
                ...state,
                settingsLoading: false,
                settingsError: action.payload,
            }
        default:
            return state;
    }
}

export default settingsReducer;
